var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('comp-table',{attrs:{"title":"确认转发统计","columns":_vm.columns,"table-api":"/gateway/chat/app/chat/group/selectUserAfficheReadView?reader=false"}}),_c('CompModal',{ref:"modal",attrs:{"title":"转发统计","width":"400px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }